import { useState, useRef, useEffect } from "react";
import { Calendar } from "../ui/calendar";
import { Input } from "../ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { CalendarBlank } from "@phosphor-icons/react";
import { de } from "date-fns/locale";

// Parse German date format (DD.MM.YYYY) to Date object
function parseGermanDate(dateStr) {
  if (!dateStr) return null;
  const parts = dateStr.split(".");
  if (parts.length !== 3) return null;
  const day = parseInt(parts[0], 10);
  const month = parseInt(parts[1], 10) - 1;
  const year = parseInt(parts[2], 10);
  if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
  const date = new Date(year, month, day);
  if (date.getDate() !== day || date.getMonth() !== month || date.getFullYear() !== year) return null;
  return date;
}

// Format Date object to German date format (DD.MM.YYYY)
function formatGermanDate(date) {
  if (!date) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
}

export function DateInput({ value, onChange, placeholder = "TT.MM.JJJJ", className = "", testId = "" }) {
  const [open, setOpen] = useState(false);
  const [inputValue, setInputValue] = useState(value || "");
  const inputRef = useRef(null);

  useEffect(() => {
    setInputValue(value || "");
  }, [value]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    onChange(newValue);
  };

  const handleCalendarSelect = (date) => {
    if (date) {
      const formatted = formatGermanDate(date);
      setInputValue(formatted);
      onChange(formatted);
    }
    setOpen(false);
  };

  const selectedDate = parseGermanDate(inputValue);

  return (
    <div className="relative flex items-center">
      <Input
        ref={inputRef}
        data-testid={testId}
        value={inputValue}
        onChange={handleInputChange}
        placeholder={placeholder}
        className={`pr-8 ${className}`}
      />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <button
            type="button"
            className="absolute right-2 p-1 text-muted-foreground hover:text-foreground transition-colors"
            title="Kalender öffnen"
          >
            <CalendarBlank className="h-4 w-4" />
          </button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="end">
          <Calendar
            mode="single"
            selected={selectedDate}
            onSelect={handleCalendarSelect}
            locale={de}
            initialFocus
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
